import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import isEqual from 'lodash/isEqual';
import ColorPalletMenu, { defaultColorPallets } from '@/components/Editor/Form/fields/ColorPalletMenu';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PlusIcon = function PlusIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("line", {
      x1: "12",
      y1: "5",
      x2: "12",
      y2: "19"
    }), /*#__PURE__*/_jsx("line", {
      x1: "5",
      y1: "12",
      x2: "19",
      y2: "12"
    })]
  }));
};

PlusIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "align-middle"
};

const ThemeVariants = _ref => {
  let {
    nameSpace,
    colorPallet,
    colorPallets: themeColorPallets,
    palletColorOverrides,
    disabled = false,
    colorsPreviewLimit = 4,
    defaults,
    onChange = () => null,
    onMenuOpenChange,
    onOverridePalletColors
  } = _ref;
  // Limit the number of colors to show in the preview
  const colorsPreview = themeColorPallets.slice(0, colorsPreviewLimit);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.variants,
    children: [colorsPreview.map(pallet => {
      const palletKey = `${nameSpace}-${pallet.name}`;
      const colorsPreview = pallet.colors.slice(0, 4); // show only first 4 colors

      const active = isEqual(pallet.colors, colorPallet);
      return /*#__PURE__*/_jsx("button", {
        type: "button",
        className: clsx(styles.variant, {
          [styles['variant--active']]: active,
          [styles['variant--disabled']]: disabled
        }),
        style: {
          outlineColor: pallet.colors[0]
        },
        onClick: () => onChange(pallet.colors),
        children: /*#__PURE__*/_jsx("div", {
          className: styles.colors,
          children: colorsPreview.map(color => {
            return /*#__PURE__*/_jsx("span", {
              className: styles.color,
              style: {
                backgroundColor: color
              }
            }, `${palletKey}-${color}`);
          })
        })
      }, palletKey);
    }), /*#__PURE__*/_jsx(ColorPalletMenu, {
      colors: colorPallet,
      defaultColors: defaults === null || defaults === void 0 ? void 0 : defaults.colors,
      colorPallets: (defaults === null || defaults === void 0 ? void 0 : defaults.colorPallets) ?? defaultColorPallets,
      palletColorOverrides: palletColorOverrides,
      className: styles.colorPalletMenu,
      OpenButton: ColorPalletsOpenButton,
      onChange: onChange,
      onMenuOpenChange: onMenuOpenChange,
      onOverridePalletColors: onOverridePalletColors
    })]
  });
};

const ColorPalletsOpenButton = _ref2 => {
  let {
    setReference,
    getReferenceProps
  } = _ref2;
  return /*#__PURE__*/_jsxs("button", _objectSpread(_objectSpread({
    ref: setReference,
    type: "button",
    className: styles.openButton
  }, getReferenceProps()), {}, {
    children: [/*#__PURE__*/_jsx(PlusIcon, {}), /*#__PURE__*/_jsx("div", {
      className: styles.openButton__badge,
      children: "20+"
    })]
  }));
};

export default ThemeVariants;